import { getDomain } from 'app/common/lib/params'
import api from './api'
import config from '../config'

export const DEALER_REQUEST = 'DEALER_REQUEST'
export const DEALER_SUCCESS = 'DEALER_SUCCESS'
export const DEALER_FAILURE = 'DEALER_FAILURE'

/**
 * Получение данных дилера
 */

export const dealerRequest = () => ({
  type: DEALER_REQUEST,
})

export const dealerSuccess = (payload) => ({
  type: DEALER_SUCCESS,
  payload,
})

export const dealerFailure = (payload) => ({
  type: DEALER_FAILURE,
  payload,
})

export const dealerFetch = () => async (dispatch) => {
  const domain = getDomain()
  dispatch(dealerRequest())

  try {
    const res = await api('cabinet/dealer', 'get', { params: { domain } })
    localStorage.phone = res.data.phone || ''
    dispatch(
      dealerSuccess({
        logo_url: res.data.logo_url ? res.data.logo_url : config.defaultLogo,
        logo_w_url: res.data.secondary_logo_url
          ? res.data.secondary_logo_url
          : config.defaultLogoWhite,
        company: res.data.company || config.copyrightName,
        phone: res.data.phone || '',
        project_name: res.data.project_name,
        parentRegistrationTypes: res.data.parent_registration_types,
        country_iso_code: res.data.country_iso_code,
        enable_reassign_identifiers_by_parents: res.data.enable_reassign_identifiers_by_parents,
        android_app_url: res.data.android_app_url || '',
        ios_app_url: res.data.ios_app_url || '',
        school_type: res.data.school_type || '',
        email_force_auth: res.data.email_force_auth || false,
        e_money_enabled: res.data.e_money_enabled || false,
        e_money_max_balance: res.data.e_money_max_balance || null,
      }),
    )
  } catch (error) {
    dispatch(
      dealerFailure({
        logo_url: config.defaultLogo,
        logo_w_url: config.defaultLogoWhite,
        company: config.copyrightName,
        phone: localStorage.phone || null,
      }),
    )
  }
}
